/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Hide_Event_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Hide current event" |
*
* @param {Timing_Sync_Hide_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_hide_event_aria_label = /** @type {((inputs?: Timing_Sync_Hide_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Hide_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masquer l'evenement actuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelles Ereignis ausblenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nascondi evento corrente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скрыть текущее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ocultar evento actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐藏当前事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のイベントを非表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान घटना को छुपाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocultar evento atual")
	return /** @type {LocalizedString} */ ("Hide current event")
});